export default __webpack_public_path__ + "static/media/syrupbottle.61b05fa6.png";